export const getRecaptchaToken = () =>
  // @ts-ignore
  window.grecaptcha
    ?.execute('6Lc3x7UpAAAAAN7y4W3PKG-DE_2pxPSme5C0E_e2', {
      action: 'submit',
    })
    .catch(() => 'no-token');
